import { SignupRoute, SignupRouteParams } from "../SignupFlow/SignupFlow"
import { Button, Card, CardMedia, Grid, Theme, Typography, useMediaQuery } from "@mui/material"
import { useTranslation } from "react-i18next"
import { useEffect, useState } from "react"
import { getWebCampaign } from "../../../services/ntuc/memberService/campaign"
import finance from "../../../assets/benefits/finance.svg"
import protection from "../../../assets/benefits/protection.svg"
import cost from "../../../assets/benefits/cost.svg"
import training from "../../../assets/benefits/training.svg"
import family from "../../../assets/benefits/family.svg"
import { useCookies } from 'react-cookie'
import PillarItem from "../../../components/PillarItem/PillarItem"
import { useSignupStore } from "../../../store/signup/UserSignupStore"
import { ActionType } from "../../../store/signup/SignupReducer"
import bannerPlaceholder from "../../../assets/campaign_banner_placeholder.svg"
import { AppCookies } from "../../../helpers/cookies"

function IntroductionPage(params: SignupRouteParams) {
    const { onNavigateTo } = params
    const { t } = useTranslation(`introduction`)
    const [bannerUrl, setBannerUrl] = useState(bannerPlaceholder)
    const isScreenSm = useMediaQuery((theme: Theme) => theme.breakpoints.down(`sm`))
    const isScreenXs = useMediaQuery(`(max-width:400px)`)
    const [, setCookie] = useCookies()
    const [, dispatch] = useSignupStore()
    const handleOnStartClick = () => {
        onNavigateTo(SignupRoute.Disclaimer)
    }

    const handleOnRetrieveDraftClick = () => {
        onNavigateTo(SignupRoute.Draft)
    }

    const buildAssetUrl = (location: string) => {
        return window.myNtucConfig.assetsBaseUrl + location
    }

    const sxButtonApplication = () => {
        if(isScreenXs){
            return `14px`
        }
        else if(isScreenSm) {
            return `18px`
        }
        else {
            return `22px`
        }
    }

    useEffect(() => {
        dispatch({ type: ActionType.CLEAR, value: {} })

        getWebCampaign(window.myNtucConfig.campaignCode)
            .then(response => response.data.content)
            .then(campaign => {
                setCookie(AppCookies.CAMPAIGN_CODE, campaign.campaign_code, {
                    path: `/`,
                })

                dispatch({
                    type: ActionType.UPDATE_CAMPAIGN,
                    value: {
                        code: campaign.campaign_code,
                        app: campaign.calling_app,
                        callback: campaign.callback_url,
                    },
                })
                return campaign.banner_image
            })
            .then(buildAssetUrl)
            .then(setBannerUrl)
    }, [setCookie])

    return (
        <Grid container rowSpacing={3} padding={2} justifyContent="center">
            <Grid item m='auto' xs={12} md={8}>
                <Typography variant='h1' align='center'>{t(`title`)}</Typography>
            </Grid>

            <Grid item m='auto' xs={12} md={12} hidden={!bannerUrl}>
                <Grid container justifyContent="center">
                    <Grid item xs={12} md={8}>
                        <Card sx={{ border: `none`, boxShadow: `none` }}>
                            <CardMedia
                                sx={{ width: `100%`, objectFit: `contain`, borderRadius: { xs: `20px`, md: `50px` } }}
                                component="img"
                                image={bannerUrl}
                                alt="Campaign Banner"
                            />
                        </Card>
                    </Grid>
                </Grid>
            </Grid>

            <Grid item container rowSpacing={3} justifyContent="center">
                <PillarItem icon={protection} subtitle="subtitle1" caption="caption1" />
                <PillarItem icon={training} subtitle="subtitle2" caption="caption2" />
                <PillarItem icon={cost} subtitle="subtitle3" caption="caption3" />
                <PillarItem icon={finance} subtitle="subtitle4" caption="caption4" />
                <PillarItem icon={family} subtitle="subtitle5" caption="caption5" />
                <PillarItem />
            </Grid>

            <Grid container item xs={8} sm={6} justifyContent="center">
                <Grid item xs={11} md={9}>
                    <Button size="large" sx={{fontSize: sxButtonApplication, height: `4rem`}} onClick={handleOnStartClick} variant="contained" color="primary" fullWidth>
                        {t(`start`)}
                    </Button>
                </Grid>
            </Grid>

            <Grid container item xs={8} sm={6} justifyContent="center">
                <Grid item xs={11} md={9}>
                    <Button size="large" sx={{fontSize: sxButtonApplication, height: `4rem`}} onClick={handleOnRetrieveDraftClick} variant="outlined" color="primary" fullWidth>
                        {t(`draft`)}
                    </Button>
                </Grid>
            </Grid>
        </Grid >
    )
}

export default IntroductionPage